import React from 'react';

const styles = {
  button: {
    padding: '10px 15px',
    fontSize: '14px',
    cursor: 'pointer',
    border: '1px solid transparent',
    borderRadius: '4px'
  },
  primary: {
    backgroundColor: '#007bff',
    color: 'white',
    borderColor: '#007bff'
  }
};

const Button = ({ children, onClick, primary, style, ...rest }) => (
  // eslint-disable-next-line react/button-has-type
  <button
    style={{
      ...styles.button,
      ...(primary ? styles.primary : {}),
      ...style
    }}
    onClick={onClick}
    {...rest}
  >
    {children}
  </button>
);

export default Button;
